import { Field, FieldRenderProps } from 'react-final-form';
import { FieldValidator } from 'final-form';
import * as React from 'react';
import {
  Stack,
  Label,
  Hint,
  InputError,
  Box,
  StackProps,
  LabelProps,
} from '@hygraph/baukasten';
import { generateRandomId } from 'utils';
import { isObject } from 'lodash';

interface SwitchGFieldProps {
  name: string;
  label?: string | JSX.Element;
  hint?: string;
  disabled?: boolean;
  type?: string;
  value?: string;
  validate?: FieldValidator<any>;
  hideErrors?: boolean;
  labelProps?: LabelProps;
  render: (fieldProps: FieldRenderProps<any>) => JSX.Element | null;
}

export const CheckboxGField: React.FC<
  SwitchGFieldProps & Partial<StackProps>
> = ({
  name,
  label,
  render,
  hint,
  type,
  value,
  disabled = false,
  validate,
  hideErrors = false,
  labelProps = {},
  ...rest
}) => {
  const fieldId = `${name}-${generateRandomId()}`;
  return (
    <Field name={name} type={type} value={value} validate={validate}>
      {({ input, meta }) => {
        const { error, touched } = meta;
        const hasError = hideErrors ? false : !!error && touched;

        return (
          <Stack gap="4" {...rest}>
            <Label
              gap="8"
              htmlFor={fieldId}
              sx={{ width: 'fit-content' }}
              {...labelProps}
            >
              {render({ input: { ...input, id: fieldId }, meta })}
              <Box
                as="span"
                color={
                  disabled ? 'input.label.disabled' : 'input.label.default'
                }
              >
                {label}
              </Box>
            </Label>
            {hint && (
              <Hint
                ml="24"
                color={disabled ? 'input.hint.disabled' : 'input.hint.default'}
              >
                {hint}
              </Hint>
            )}
            {hasError ? (
              isObject(error) ? (
                Object.values(error).map((e, index) => (
                  <InputError key={index}>{e}</InputError>
                ))
              ) : (
                <InputError>{error}</InputError>
              )
            ) : null}
          </Stack>
        );
      }}
    </Field>
  );
};
